import request from '@/axios'
import type {
  ChangeUserPasswordParams,
  SaveUserInfoParams,
  UserAvatarParams,
  UserLoginApiParams,
  UserTokenType,
  UserPhoneLoginApiParams
} from './types'
import { UserItem } from '../user/types'

export const loginApi = (data: UserLoginApiParams): Promise<IResponse<UserTokenType>> => {
  return request.post({ url: '/Authorization/connect/token', data })
}

export const loginPhoneApi = (data: UserPhoneLoginApiParams): Promise<IResponse<UserTokenType>> => {
  return request.post({ url: '/Authorization/connect/token', data })
}

export const getUserInfoApi = () => {
  return request.get<UserItem>({ url: '/Authorization/GetUserInfo' })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/Authorization/loginOut' })
}

export const saveUserInfo = (data: SaveUserInfoParams): Promise<IResponse> => {
  return request.post({ url: '/Authorization/SaveUserInfo', data })
}

export const changeUserPassword = (data: ChangeUserPasswordParams): Promise<IResponse> => {
  return request.post({ url: '/Authorization/ChangeUserPassword', data })
}

export const uploadAvatar = (data: UserAvatarParams): Promise<IResponse> => {
  return request.post({ url: '/Authorization/UploadAvatar', data })
}

export const getCode = (email: string): Promise<IResponse> => {
  return request.get({ url: '/Authorization/GetVerificationCode', params: { email } })
}
